<template>
  <div>
    <h2 class="text-sm font-semibold text-[#23569F] uppercase">{{ $t('playerSetup.addPlayerToPlan') }}</h2>
    <el-row v-if="filteredInvoiceSummary" :gutter="16" class="plan-summary px-[40px] text-sm uppercase">
      <el-col :span="12" class="currentPlan">
        <h2 class="font-semibold pb-4 pt-8 text-sm text-[#23569F] uppercase">{{ $t('playerSetup.currentPlan') }}</h2>
        <div class="bg-[#F0F0F0] p-[30px]">
          <el-row class="pb-4 pt-4 border-b border-[#CCCCCC99] font-bold">
            <el-col :span="12">{{ $t('playerSetup.numberOfPlayers') }}</el-col>
            <el-col :span="12">{{ filteredInvoiceSummary.currentPlanSummary.playerCount }}</el-col>
          </el-row>
          <el-row class="pb-4 pt-4 border-b border-[#CCCCCC99]">
            <el-col :span="12">{{ $t('label.subtotal') }}</el-col>
            <el-col :span="12">{{ filteredInvoiceSummary.currentPlanSummary.subTotal }}</el-col>
          </el-row>
          <el-row class="pt-4">
            <el-col :span="12">{{ $t('label.vat') }} {{ filteredInvoiceSummary.vatInPercent }}</el-col>
            <el-col :span="12">{{ filteredInvoiceSummary.currentPlanSummary.vat }}</el-col>
          </el-row>
          <el-row class="pt-[30px] text-base font-bold">
            <el-col :span="12" :offset="12">{{ filteredInvoiceSummary.currentPlanSummary.total }} / {{ $t('template.month') }} </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="12" class="updatedPlan">
        <h2 class="font-semibold pb-4 pt-8 text-sm text-[#23569F] uppercase">{{ $t('playerSetup.updateTo') }}</h2>
        <div class="bg-[#DCEAFF] p-[30px]">
          <el-row class="pb-4 pt-4 border-b border-[#CCCCCC99] font-bold">
            <el-col :span="12">{{ $t('playerSetup.numberOfPlayers') }}</el-col>
            <el-col :span="12">{{ filteredInvoiceSummary.newPlayerCount }}</el-col>
          </el-row>
          <el-row class="pb-4 pt-4 border-b border-[#CCCCCC99]">
            <el-col :span="12">{{ $t('label.subtotal') }}</el-col>
            <el-col :span="12">{{ filteredInvoiceSummary.subTotal }}</el-col>
          </el-row>
          <el-row class="pt-4">
            <el-col :span="12">{{ $t('label.vat') }} {{ filteredInvoiceSummary.vatInPercent }}</el-col>
            <el-col :span="12">{{ filteredInvoiceSummary.vat }}</el-col>
          </el-row>
          <el-row class="pt-[30px] text-base font-bold">
            <el-col :span="12" :offset="12">{{ filteredInvoiceSummary.total }} / {{ $t('template.month') }}</el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="24" class="text-center normal-case">
          <p class="text-sm mt-4">
            {{ $t('plans.review.termsAndConditionsMain') }}
            <strong>{{ $t('plans.review.termsAndConditionsSub') }}</strong>
          </p>
      </el-col>
    </el-row>
    <div v-else class="flex flex-col items-center">
      <div class="w-1/2 m-4">
        <player-setup-form-error :display="errorMessage != ''" height="auto">
          <h2 class="text-lg mb-2">{{ $t('label.somethingWentWrong') }}</h2>
          <p class="mb-4">{{ errorMessage }}</p>
        </player-setup-form-error>
      </div>
    </div>
  </div>
</template>

<script src="./player-setup-plan-summary.js"></script>
